import {
  ensureBrandCapabilitiesLoaded,
  getBrandCapabilityStatus,
} from '@/features/hestia/queries/useBrandCapabilities'
import { logError } from '@/logger'
import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const PROMO_CARDS_ROUTES = ['brand.conversion-cards', 'brand.marketing.flyers']

export const checkConversionCardsFeatureFlag: HermesGuardFn = async (to) => {
  if (typeof to.name !== 'string' || !PROMO_CARDS_ROUTES.includes(to.name)) {
    return undefined
  }

  const featureFlags = useFeatureFlags()
  const redirectHome = {
    name: 'brand.home',
    params: { brandId: to.params.brandId },
  }

  if (!featureFlags.isEnabled('hermes.conversionCardsPage')) {
    return redirectHome
  }

  if (!featureFlags.isEnabled('hermes.jpcMiBPromoCardsGate')) {
    return undefined
  }

  const brandId = to.params.brandId
  // Brand-scoped routes always carry a string brandId; if one is somehow absent
  // we can't load capabilities to evaluate the gate, so fail closed rather than
  // read a stale shared ref.
  if (typeof brandId !== 'string' || !brandId) {
    return redirectHome
  }

  // The guard runs before the layout components that mount
  // useBrandCapabilitiesQuery, so on a direct URL / hard refresh the shared
  // capabilities ref is still empty and getBrandCapabilityStatus returns
  // undefined — letting a gated brand reach the page. Load it here so the gate
  // also holds for direct navigation. Fail open on a fetch error to avoid
  // stranding a legitimate brand, matching checkBrandAccess.
  try {
    await ensureBrandCapabilitiesLoaded(brandId)
  } catch (error) {
    logError(error, {
      attemptedBrandId: brandId,
      context: 'checkConversionCardsFeatureFlag',
    })
    return undefined
  }

  if (getBrandCapabilityStatus('marketing', 'promo-cards') === 'disabled') {
    return redirectHome
  }

  return undefined
}
